module.exports = __webpack_public_path__ + "static/media/info-blue.e6d855b2.svg";